import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

type AutoCompleteSearchButtonProps = {
  dataCy: string;
  isReadOnly: boolean;
  onClick: () => void;
};

/**
 * Loupe des champs d'autocompletion Azure AD / famille: seul declencheur de l'appel API de recherche.
 * Comme sur Android, elle n'est pas affichee pour un champ en lecture seule.
 */
const AutoCompleteSearchButton = ({ dataCy, isReadOnly, onClick }: AutoCompleteSearchButtonProps) => {
  const { t } = useTranslation('declaration');

  if (isReadOnly) return null;

  const label = t('formlib_autocomplete_search_button').toString();

  return (
    <Tooltip title={label}>
      <IconButton data-cy={dataCy} aria-label={label} onClick={onClick}>
        <SearchIcon />
      </IconButton>
    </Tooltip>
  );
};

export default AutoCompleteSearchButton;
